import { SharedConstants } from "../../../../shared/constants/shared.constants";
export class CreateLocationDMConstants {
    static STEP_TITLE = "Location";
    static OWNER_LABEL = "Owners";
    static REMOVE_PROPERTY_LABEL = "Remove property";
    static COPY_OWNER_LABEL = "Copy owner to applicant";
    static DESCRIPTION_LABEL_1 = "Search the map to find the property for which you are lodging an application, using the 'Find address or place' search bar.";
    static DESCRIPTION_LABEL_2 = "Zoom in close enough to the correct property and click on the property. Click on 'add property' in the window that appears on the map after you selected the property.";
    static DESCRIPTION_LABEL_3 = "The property will be added and the fields must be completed for the property. Please note that multiple properties may be added.";
    static DESCRIPTION_LABEL_4 = "Please note that the zoning here is the current zoning of the property. Please note that an owner should be added for each property (this is linked to the property and the application).";
    static PROPERTIES_FORM_GROUP_NAME = "propertiesForm";
    static ERF_NO_CONTROL = "erfNo";
    static SUBDIVISION_CONTROL = "subdivision";
    static FARM_NO_CONTROL = "farmNo";
    static ALLOTMENT_CONTROL = "allotment";
    static SG_CODE_CONTROL = "sgCode";
    static ADDRESS_CONTROL = "address";
    static CADASTRAL_DESCRIPTION_CONTROL = "cadastralDescription";
    static RATE_NUMBER_CONTROL = "rateNumber";
    static EXISTING_USE_CONTROL = "existingUse";
    static WORTHY_OF_PRESERVATION_CONTROL = "worthyOfPreservation";
    static REASON_CONTROL = "reason";
    static OVER_60_CONTROL = "over60";
    static AMAFA_PERMISSION_CONTROL = "amafaPermission";
    static OWNER_CONTROL = "owners";
    static ERF_NO_TEXT_PLACEHOLDER = "Erf no";
    static SUBDIVISION_TEXT_PLACEHOLDER = "Subdivision / portion number";
    static FARM_NO_TEXT_PLACEHOLDER = "Farm no";
    static ALLOTMENT_TEXT_PLACEHOLDER = "Allotment / suburb";
    static SG_CODE_TEXT_PLACEHOLDER = "SG Code";
    static ADDRESS_TEXT_PLACEHOLDER = "Address";
    static CADASTRAL_DESCRIPTION_TEXT_PLACEHOLDER = "Cadastral description";
    static RATE_NUMBER_TEXT_PLACEHOLDER = "Rate number";
    static EXISTING_USE_TEXT_PLACEHOLDER = "Existing use";
    static WORTHY_OF_PRESERVATION_TEXT_PLACEHOLDER = "Is the Building listed as worthy of preservation in Appendix 7 of the Town Planning Regulations?";
    static REASON_TEXT_PLACEHOLDER = "Reason for demolition";
    static OVER_60_TEXT_PLACEHOLDER = "Is the Building over 60 Years old?";
    static AMAFA_PERMISSION_TEXT_PLACEHOLDER = "Has permission to demolish been obtained from AMAFA?";
    static NO_APPLICANT_AVAILABLE = "There is no applicant available";
    static DUPLICATE_MESSAGE = "The selected property has already been added";
    static TRUE_CENTROID = "True centroid gp shared-services";
    static PROPERTY_LAYER_NAME = "Demolition management graphics";
    static ONLY_ONE_PROPERTY_ALLOWED = "Only one property can be added per application.";
    static INVALID_OWNER_ATTRIBUTE = "Some owner attribute(s) is missing on the property owner layer. Please contact your systems administrator.";
    static NO_OWNERS_SELECTED_MESSAGE = "Please select an owner to copy to applicant";
    static MULTIPLE_OWNERS_SELECTED_MESSAGE = "Multiple owners have been selected, please select only one to copy to applicant";
    static COPY_OWNER_TO_APPLICANT_SUCCESS_MESSAGE = "Owner successfully copied to applicant";
    static VALIDATION_MESSAGES = {
        erfNo: {
            required: `Erf no ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        subdivision: {
            required: `Subdivision ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        allotment: {
            required: `Allotment ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        farmNo: {
            required: `Farm no ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        sgCode: {
            required: `SG code ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        address: {
            required: `Address ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        cadastralDescription: {
            required: `Cadastral description ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        rateNumber: {
            required: `Rate number ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        existingUse: {
            required: `Existing use ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        worthyOfPreservation: {
            required: `Worthy of preservation ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        reason: {
            required: `Reason ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        over60: {
            required: `Over 60 ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        amafaPermission: {
            required: `Amafa permission ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
    };
}
